import { Component, OnInit, OnDestroy } from '@angular/core';
import { CognitoService } from '../services/cognito.service';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Subscription } from 'rxjs';
import { MenuProviderService } from '../services/menu-provider.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  isAdmin = false;
  isAuthenticated = false;
  private authSubscription: Subscription | null = null;
  opened = true;
  loggedInUsername = '';
  constructor(
    public authenticator: AuthenticatorService,
    public cognitoService: CognitoService,
    public menuProviderService: MenuProviderService
  ) {}

  get menuItems() {
    // Slice(1) to remove 'home'
    // Show only the ones enabled via 'show' property
    return this.menuProviderService
      .getMenuItems()
      .slice(1)
      .filter(item => item.show);
  }

  ngOnInit() {
    // Subscribe to authentication status
    this.authSubscription = this.cognitoService.isAuthenticated().subscribe(async isAuth => {
      this.isAuthenticated = isAuth;
      if (isAuth) {
        this.isAdmin = await this.cognitoService.isAdmin();
        const userName = await this.cognitoService.getUserEmail();
        this.loggedInUsername = userName.split('@')[0];
      } else {
        this.isAdmin = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }
}
